import { apiClient } from '../utils/apiClient';

class NotificationsService {
  // Get all notifications for the current user
  async getNotifications(unreadOnly = false) {
    try {
      const params = unreadOnly ? { unread_only: true } : {};
      const response = await apiClient.get('/notifications', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch notifications');
    }
  }

  // Get unread notifications count
  async getUnreadCount() {
    try {
      const response = await apiClient.get('/notifications/unread-count');
      return response.data.unread_count;
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch unread count');
    }
  }

  // Mark a notification as read
  async markAsRead(notificationId) {
    try {
      const response = await apiClient.put(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
      throw new Error(error.response?.data?.message || 'Failed to mark notification as read');
    }
  }

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      const response = await apiClient.put('/notifications/mark-all-read');
      return response.data;
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      throw new Error(error.response?.data?.message || 'Failed to mark all notifications as read');
    }
  }

  // Delete a notification
  async deleteNotification(notificationId) {
    try {
      const response = await apiClient.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete notification:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete notification');
    }
  }

  // Search for users by email
  async searchUserByEmail(email) {
    try {
      const response = await apiClient.get('/teams/search-users', {
        params: { email }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to search user:', error);
      throw new Error(error.response?.data?.message || 'Failed to search user');
    }
  }

  // Send team invitation
  async sendTeamInvitation(teamId, email, role = 'editor') {
    try {
      const response = await apiClient.post(`/teams/${teamId}/invite`, { email, role });
      return response.data;
    } catch (error) {
      console.error('Failed to send team invitation:', error);
      throw new Error(error.response?.data?.message || 'Failed to send team invitation');
    }
  }



  // Clear all read notifications for the current user
  async clearReadNotifications() {
    try {
      const response = await apiClient.delete('/notifications/read');
      return response.data;
    } catch (error) {
      console.error('Failed to clear read notifications:', error);
      throw new Error(error.response?.data?.message || 'Failed to clear read notifications');
    }
  }

  // Get pending invitations for a team
  async getTeamInvitations(teamId) {
    try {
      const response = await apiClient.get(`/teams/${teamId}/invitations`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch team invitations:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch team invitations');
    }
  }
}

const notificationsService = new NotificationsService();
export default notificationsService;
